const RESET_SITE_ROLES = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/RESET_SITE_ROLES'
const RESET_SITE_ROLES_CHANGE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/UPDATE_SITE_ROLES'
const UPDATE_SITE_ROLES = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/UPDATE_SITE_ROLES'
const UPDATE_SITE_ROLES_CHANGE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/UPDATE_SITE_ROLES_CHANGE'

const FETCH_SITE_ROLES = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/FETCH_SITE_ROLES'
const FETCH_SITE_ROLES_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/FETCH_SITE_ROLES_START'
const FETCH_SITE_ROLES_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/FETCH_SITE_ROLES_SUCCESS'
const FETCH_SITE_ROLES_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/FETCH_SITE_ROLES_ERROR'

const POST_SITE_ROLES = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/POST_SITE_ROLES'
const POST_SITE_ROLES_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/POST_SITE_ROLES_START'
const POST_SITE_ROLES_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/POST_SITE_ROLES_SUCCESS'
const POST_SITE_ROLES_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteRole/POST_SITE_ROLES_ERROR'

const TEAM_ENUM = Object.freeze({
  CUSTOMER_PROGRAM_MANAGER: 'Customer Program Manager',
  ACCOUNT_APPLICATIONS_ENGINEER: 'Account Applications Engineer',
  APPLICATIONS_ENGINEERING_MANAGER: 'Applications Engineering Manager',
  FIELD_APPLICATIONS_ENGINEER: 'Field Applications Engineer',
  ACCOUNT_MANAGER: 'Account Manager',
  CUSTOMER_PROGRAM_DIRECTOR: 'Customer Program Director',
  SOFTWARE_PROGRAM_MANAGER: 'Software Program Manager',
  OBSERVER: 'Observer',
})

export {
  TEAM_ENUM,
  RESET_SITE_ROLES,
  RESET_SITE_ROLES_CHANGE,
  UPDATE_SITE_ROLES_CHANGE,
  UPDATE_SITE_ROLES,
  FETCH_SITE_ROLES,
  FETCH_SITE_ROLES_START,
  FETCH_SITE_ROLES_SUCCESS,
  FETCH_SITE_ROLES_ERROR,
  POST_SITE_ROLES,
  POST_SITE_ROLES_START,
  POST_SITE_ROLES_SUCCESS,
  POST_SITE_ROLES_ERROR,
}
